export const ADD_TO_CART_BUTTON_ID = 'add-to-cart-button';
